__turbopack_context__.v({
  "bar": "Nxapoa_bar",
  "container": "Nxapoa_container",
});
